export const REGISTER_USER = "register_user"
export const REGISTER_USER_SUCCESSFUL = "register_user_successfull"
export const REGISTER_USER_FAILED = "register_user_failed"
export const VERIFY_CODE ="VERIFY_CODE"
export const VERIFY_CHECK ="VERIFY_CHECK"
export const PASSWORD_FORGOT ="PASSWORD_FORGOT"
export const RESENT_CODE  ="RESEND_CODE"
